import dayjs from "dayjs";
import styles from "./itemcard.module.css";
import { useHistory } from "react-router-dom";

const ItemCard = ({ item }) => {
    const history = useHistory();

    return (<div className={`${styles.CardDivList}`} onClick={() => history.push('/campaign/logs/' + item?.id)}>
        <div className={`${styles.FirstSec}`}>
            <div>
                <p className={`${styles.Name}`}>
                    {item?.subject}
                    {item?.status === 0 && <span className={`${styles.StatusBadge} ${styles.Sending}`}>Sending</span>}
                    {item?.status === 1 && <span className={`${styles.StatusBadge} ${styles.Sent}`}>Sent</span>}
                </p>
                <p className={`${styles.Name}`}>{dayjs(item?.created_at).format('ddd, MMM D, hh.mm A')} by {item?.user_name}</p>
            </div>
        </div>
        <div className={`${styles.SecondSec}`}>
            <p className={`${styles.Name}`}><span>{item?.audience_name}</span></p>
            <p className={`${styles.Name}`}><span>{item?.no_of_emails > 1 ? item?.no_of_emails + ' recipients' : item?.no_of_emails + ' recipient'}</span></p>
        </div>
        <div className={`${styles.ThirdSec}`}>
            <p className={`${styles.Name}`}>{item?.delivery_percentage}% <span>Delivery</span></p>
            <p className={`${styles.Name}`}>{item?.open_percentage}% <span>Clicks</span></p>
            <p className={`${styles.Name}`}>{item?.click_percentage}% <span>Clicks</span></p>
        </div>
    </div>)
}

export default ItemCard;